import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { AUTO_LOGOUT_TIMEOUT } from '../config';
import { useIdleTimer } from 'react-idle-timer';
import {useHistory} from "react-router";

const IdleTimerCheck = ({ children }) => {

  const authState = useSelector((state) => state.auth);
  const history = useHistory();
  const idleTimerRef = useRef();

  // Idle timer functions, only used when isLoggedIn == true
  const [idleTimerState, setIdleTimerState] = useState({
    timeout: AUTO_LOGOUT_TIMEOUT,
    showModal: false,
    isTimedOut: false
  })


  const checkLastActivity = () => {

    const currentTime = new Date().getTime()
    if (!idleTimerRef.current)
      return;

    const difference = currentTime - idleTimerRef.current.getLastActiveTime()
    const milliSecondsDifference = difference;
    if (milliSecondsDifference >= AUTO_LOGOUT_TIMEOUT) {
      history.push('/logout?to=1')
    }
  }


  const onActive = (e) => {
    setIdleTimerState({ ...idleTimerState, isTimedOut: false })
    checkLastActivity()
  }

  const onIdle = (e) => {

    const isTimedOut = idleTimerState.isTimedOut

    history.push('/logout?to=1')

  }

  const onAction = (e) => { //console.log("IDLE TIMER ACTION ", e)  
  }
  
  const idleTimer = useIdleTimer({

    onIdle,
    onActive,
    onAction,
    timeout: AUTO_LOGOUT_TIMEOUT,
    promptTimeout: 0,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange'
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: true,
    stopOnIdle: false,
    crossTab: true,
    name: 'idle-timer',
    syncTimers: 0,
    ref: idleTimerRef,
    leaderElection: false
  })

  if (authState.isLoggedIn)
    idleTimer.start();
  else
    idleTimer.pause();


  return children;
};

export default IdleTimerCheck;